/**
 * @generated SignedSource<<1ac3f7025eab1154edc1c87b60399845>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalEditMainPushNotification_signalWorkspace$data = {
  readonly id: string;
  readonly sendNotificationAtPublish: boolean;
  readonly updatedAtDate: {
    readonly isoString: string;
    readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
  } | null;
  readonly updatedBy: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly " $fragmentType": "WorkspaceSignalEditMainPushNotification_signalWorkspace";
};
export type WorkspaceSignalEditMainPushNotification_signalWorkspace$key = {
  readonly " $data"?: WorkspaceSignalEditMainPushNotification_signalWorkspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalEditMainPushNotification_signalWorkspace">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceSignalEditMainPushNotification_signalWorkspace",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sendNotificationAtPublish",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnzonedDate",
      "kind": "LinkedField",
      "name": "updatedAtDate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isoString",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FormattedDate"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "updatedBy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "SignalWorkspace",
  "abstractKey": null
};
})();

(node as any).hash = "7c1558b503b72bb88b94789ea3fbffd2";

export default node;
